import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SidebarComponent } from "./sidebar.component";

//import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ElementosNavComponent } from "./elementos-nav/elementos-nav.component";
import { CambiopassComponent } from '../componentes/cambiopass/cambiopass.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
     FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [SidebarComponent, ElementosNavComponent, CambiopassComponent],
  exports: [SidebarComponent, ElementosNavComponent, CambiopassComponent],
})
export class SidebarModule {}
